import './style.scss';

export function page_not_found() {
  const block = document.querySelector('.page_not_found');

  if (!block) return;

}
